import Popup from 'reactjs-popup';
import Select from 'react-select'
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { useAuthState } from '../../../../../../Helper/Context';
import { useDispatch, useSelector } from 'react-redux';
import { Get_A_Report_Execution_Project_Wise_Date_SelectDataAPI } from '../../../../../../Redux/ReportExecutionSlice/ReportExecutionSlice';
import moment from 'moment';
import { Loading } from '../../../../../../Helper/Loading';


export default function ExecutionDateModal(props) {

    const { Flag, open, handleViewClose, Month, FinancialYear, GridData } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch();

    const [TableModalData, setTableModalData] = useState([])

    useEffect(() => {
        handleGetData()
    }, [])

    const handleGetData = () => {
        const data = {
            M_ProjectTypeID: GridData?.m_ProjectTypeID,
            M_FinancialYearID: FinancialYear?.ID,
            M_MonthID: Month?.ID,
            M_UsersID: UserID,
            token: token,
            setTableModalData: setTableModalData
        }
        dispatch(Get_A_Report_Execution_Project_Wise_Date_SelectDataAPI({ data }))
    }

    const { isLoading, TableData } = useSelector(state => state.Get_A_Report_Execution_Project_Wise_Date_SelectData)


    return (

        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleViewClose}
        >
            <div className="area_pop modal-dialog modal-dialog-scrollable modal-xl">
                <div className="modal-content master_border">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Report Execution Date</h4>
                        <button onClick={handleViewClose} className="btn-close m-1 mr-3" type="button" />
                    </div>
                    {isLoading && <Loading />}
                    <div className="modal-body">
                        <div className='inner-modal-body'>

                            <div className="row details-row">
                                <div className="row mob_table table-responsive pt-1" style={{ maxHeight: "400px", overflowY: "auto" }}>

                                    <table id="totalordergenerated"
                                        cellPadding="0"
                                        cellSpacing="0"
                                        border="0"
                                        className="table table-bordered">
                                        <thead style={{ position: "sticky", top: '0', zIndex: '2' }}>
                                            <tr>
                                                <th className="sr_no_col">Sr No.</th>
                                                <th>Project Type</th>
                                                <th>Execution Date </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                TableModalData && TableModalData.length > 0 ? TableModalData.map((i, j) => {
                                                    return (
                                                        <tr style={{ width: '100%' }}>
                                                            <td style={{ textAlign: "center" }}>{j + 1}</td>
                                                            <td>{i?.projectType ? i?.projectType : '-'}</td>
                                                            <td>{i?.readingDate ? moment(i?.readingDate).format('DD-MM-YYYY') : '-'}</td>
                                                        </tr>
                                                    )
                                                })
                                                    :
                                                    <tr><td colSpan={4}>No Data Found</td></tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/* <div className="col-12 col-lg-12">
                                <div className="btn-action d-flex justify-content-end mt-lg-3">

                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                    // onClick={() => handlePost()}

                                    >{Flag == "Update" ? "Update" : "Save"} </button>

                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleViewClose} >Cancel</button>
                                </div>
                            </div> */}

                        </div>

                    </div>
                </div>
            </div>

            {/* )} */}


        </Popup>
    )

}